/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monochromatic`)
};

const es_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monocromática`)
};

const de_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monochromatisch`)
};

const nl_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monochroom`)
};

const fr_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monochromatique`)
};

const it_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monocromatica`)
};

const pt_br2_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monocromática`)
};

const pt_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monocromática`)
};

const ja_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モノクロマティック`)
};

const zh_cp_monochromatic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同色系`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_monochromatic = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_monochromatic(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_monochromatic", locale)
	if (locale === "en") return en_cp_monochromatic(inputs)
	if (locale === "es") return es_cp_monochromatic(inputs)
	if (locale === "de") return de_cp_monochromatic(inputs)
	if (locale === "nl") return nl_cp_monochromatic(inputs)
	if (locale === "fr") return fr_cp_monochromatic(inputs)
	if (locale === "it") return it_cp_monochromatic(inputs)
	if (locale === "pt-BR") return pt_br2_cp_monochromatic(inputs)
	if (locale === "pt") return pt_cp_monochromatic(inputs)
	if (locale === "ja") return ja_cp_monochromatic(inputs)
	return zh_cp_monochromatic(inputs)
};